/* lua.js generated code 0.3.0 */
window.__g_utcDiffSeconds = 0;
require("clover/config/LevelType")
require("clover/data/UserManager")
require("clover/data/CacheManager")
require("clover/data/FriendManager")
require("clover/data/Persistence")
var LoginBuffer = require("clover/loader/LoginBuffer")
var kLocalDataExt = ".ds"
var kLastLoginUserConfigName = "login" + kLocalDataExt
var kSNSUserInfoName = "sns_info" + kLocalDataExt
var kDefaultConfigName = "conf" + kLocalDataExt
var fullPathOfLocalData = he.HeResPathUtils.getUserDataPath()
var kRecommendDataName = "recommend" + kLocalDataExt
var kLastLoginOauthID = "lastLoginOauthID" + kLocalDataExt
var kLastLoginTime = "lastLoginTime" + kLocalDataExt
var kIsDealRead = "isDealRead" + kLocalDataExt
var kIsNewNamePoped = "isNewNamePoped" + kLocalDataExt
var kIsNewAndroidPatchFindPopTime = "isNewAndroidPatchFindPopTime" + kLocalDataExt
var kIsNewUserDC = "kIsNewUserDC" + kLocalDataExt
var kPayRecordInfo = "payRecordInfo" + kLocalDataExt
var kIsCoinDozerPoserPoped = "isCoinDozerPoserPoped" + kLocalDataExt
var kEnergyShareRecord = "energyShareRecord" + kLocalDataExt
var kPrepropUseRecord = "prepropUseRecord" + kLocalDataExt
var kisTestSep = "istestSep" + kLocalDataExt
var kLastPopEnergyInvitePanel = "lastPopEnergyInvitePanel" + kLocalDataExt
var kInvitePanelPopDayTime = "invitePanelPopDayTime" + kLocalDataExt
var kRankDataCache = "rankDataCache" + kLocalDataExt
var kWeekGameDataDataCache = "weekGameDataCache" + kLocalDataExt
let kWeekLevelCacheData = "WeekLevelCacheData" + kLocalDataExt
let kWeekGameShareAddCountData = "WeekGameShareAddCountData" + kLocalDataExt
let kWeekGameForceOpenTimeData = "WeekGameForceOpenTimeData" + kLocalDataExt
let kLocalDailyData = "localDailyData" + kLocalDataExt
let kPropPromptGuide = "propPromptGuide" + kLocalDataExt
var kMissionRankAnimShowTime = "missionRankAnimShowTime" + kLocalDataExt
var kCompenPopoutList = "compenPopoutList" + kLocalDataExt
let kDAUserDataV2Cache = "DAUserDataV2" + kLocalDataExt
var instance = null
Localhost = table()
Localhost.getInstance = function () {
    if (!instance) {
        instance = Localhost
    }
    return instance
}
Localhost.requireLogin = function () {
    var notLogin = !_G.kUserLogin
    var notRegistered = !Localhost.isUserRegistered()
    if (NetworkConfig.useLocalServer && notLogin && notRegistered) {
        return true
    } else {
        return false
    }
}
Localhost.isUserRegistered = function () {
    var uid = UserManager.getInstance().uid
    var sk = UserManager.getInstance().sessionKey
    if (uid && sk && uid !== sk) {
        return true
    } else {
        return false
    }
}
Localhost.clock = function () {
    // WARN: maybe multi result
    return os.clock()
}
Localhost.date = function () {
    // WARN: maybe multi result
    return tostring(os.date("%y%m%d%H", Localhost.time() / 1000))
}
Localhost.dateExact = function () {
    // WARN: maybe multi result
    return tostring(os.date("%y%m%d%H%S", Localhost.time() / 1000))
}
Localhost.realSecTime = function () {
    var time = __g_utcDiffSeconds || 0
    return (os.time() + time)
}
//time
Localhost.time = function () {
    return Math.floor(Localhost.realSecTime() * 1000)
}
// add in version 1.20
Localhost.timeInSec = function () {
    return Math.floor(Localhost.realSecTime())
}
Localhost.timeInDay = function (time) {
    var timeZoneSec = 28800
    var seconds
    if (time) {
        seconds = time
    } else if (time === 0) {
        seconds = 0
    } else {
        seconds = Localhost.timeInSec()
    }
    // WARN: maybe multi result
    return Math.floor((seconds + timeZoneSec) / 86400)
}
/**
 * 通用方法，获取跨一天or不跨天的某个时辰的时间戳，常用于倒计时
 * @param {string} time 时辰 eg. "00:00:00", "04:00:00", 常来自配置
 */
Localhost.getCountDownEndTime = function (timeString) {
    let time = timeString.split(":")
    let hour = new Date(Localhost.time()).getHours()
    
    if (hour < tonumber(time[0])){
        return new Date(Localhost.time()).setHours(tonumber(time[0]), tonumber(time[1]), tonumber(time[2]), 0)
    }else {
        return new Date(Localhost.time()).setHours(tonumber(time[0]), tonumber(time[1]), tonumber(time[2]), 0) + 24*60*60*1000 //多加一天
    }
}
Localhost.getDefaultConfig = function () {
    var config = Localhost.readFromStorage(kDefaultConfigName)
    if (!config) {
        config = table([1, "td", 0], [1, "gc", 1])
    }
    if (config.td == null) {
        config.td = 0
    }
    if (config.gc == null) {
        config.gc = 1
    } //enable game center by default.
    return config
}
Localhost.saveTimeDiff = function (timeDiff) {
    var timeDiff = timeDiff || 0
    cc.log("saveTimeDiff:", timeDiff)
    var config = Localhost.getDefaultConfig()
    config.td = timeDiff
    Localhost.writeToStorage(config, kDefaultConfigName)
}
Localhost.isCgPlayed = function () {
    var config = Localhost.readUserDataFromStorage(kDefaultConfigName)
    config = config || table([1, "pl", 0])
    return config.pl
}
Localhost.saveCgPlayed = function (played) {
    var isPlayed = 0
    if (played != null) {
        isPlayed = played
    }
    var config = Localhost.readUserDataFromStorage(kDefaultConfigName)
    config = config || table([1, "pl", 0])
    config.pl = played
    Localhost.writeUserDataToStorage(config, kDefaultConfigName)
}
Localhost.saveGmeCenterEnable = function (v) {
    var enabled = 1
    if (v != null) {
        enabled = v
    }
    var config = Localhost.getDefaultConfig()
    config.gc = enabled
    Localhost.writeToStorage(config, kDefaultConfigName)
}
// open Id
Localhost.getUserOauthKeyByUserID = function (uid) {
    assert(uid, "userid should not nil")
    var oauthType = LoginBuffer.getInstance().getOAuthType()
    var key = "oauth_" + oauthType + "_" + tostring(uid) + kLocalDataExt
    return key
}
Localhost.setCurrentUserOpenId = function (oauthType, openId, accessToken, expireTime, refreshToken, expireRefresh) {
    var uid = UserManager.getInstance().uid
    if (uid) {
        //print("setCurrentUserOpenId:uid="..tostring(uid)..",openId="..tostring(openId) .. ",accessToken="..tostring(accessToken))
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName) || table()
        if (userData && userData.openId && userData.openId !== openId) { //如果openid变了，需要重新connect
            userData.connected = null
        }
        userData.openId = openId
        userData.accessToken = accessToken
        userData.oauthType = oauthType
        userData.expireTime = expireTime
        userData.refreshToken = refreshToken
        userData.expireRefresh = expireRefresh
        Localhost.writeUserDataToStorage(userData, fileName)
    } else {
        cc.log("setCurrentUserOpenId fail, userid is nil")
    }
}
Localhost.getCurrentUserOpenId = function () {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var data = Localhost.readUserDataFromStorage(fileName)
        return data
    } else {
        cc.log("getCurrentUserOpenId fail, userid is nil")
    }
    return null
}
Localhost.getFriendNotifyLastSendTime = function (friendId) {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName)
        if (userData) {
            if (userData.friendNotifyData) {
                return userData.friendNotifyData[friendId]
            }
        }
    }
}
Localhost.isFriendNotifySended = function (friendId) {
    var lastCheerTime = Localhost.getInstance().getFriendNotifyLastSendTime(friendId)
    if (null == lastCheerTime) {
        lastCheerTime = 0
    }
    var dayInSec = 60 * 60 * 24
    var lastCheerDay = Math.floor(lastCheerTime / dayInSec)
    var currentCheerDay = Math.floor(Localhost.getInstance().timeInSec() / dayInSec)
    if (lastCheerDay === currentCheerDay) {
        return true
    }
    return false
}
Localhost.setFriendNotifyLastSendTime = function (friendId) {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName)
        if (!userData) {
            userData = table()
        }
        var friendNotifyData = userData.friendNotifyData
        if (null == friendNotifyData) {
            friendNotifyData = table()
            userData.friendNotifyData = friendNotifyData
        }
        userData.friendNotifyData[friendId] = Localhost.timeInSec()
        Localhost.writeUserDataToStorage(userData, fileName)
    } else {
        cc.log("setLastInviteNoticeTime fail, userid is nil")
    }
}
Localhost.setLastInviteNoticeTime = function () {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName)
        if (userData) {
            userData.setLastInviteNoticeTime = Localhost.timeInSec()
            Localhost.writeUserDataToStorage(userData, fileName)
        }
    } else {
        cc.log("setLastInviteNoticeTime fail, userid is nil")
    }
}
Localhost.getLastInviteNoticeTime = function () {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName)
        if (userData) {
            return userData.setLastInviteNoticeTime
        }
    } else {
        cc.log("setLastInviteNoticeTime fail, userid is nil")
    }
}
Localhost.setCurrentUserOpenIdConnected = function () {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getUserOauthKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName)
        if (userData) {
            userData.connected = true
            Localhost.writeUserDataToStorage(userData, fileName)
        }
    } else {
        cc.log("setCurrentUserOpenIdConnected fail, userid is nil")
    }
}
Localhost.getLocalScoreKeyByUserID = function () {
    var platform = UserManager.getInstance().platform
    var uid = UserManager.getInstance().uid
    var key = tostring(platform) + "_u_" + tostring(uid) + "_score" + kLocalDataExt
    return key
}
Localhost.cleanLastScoreSyncTime = function () {
    var __VA_ARG = $slice(arguments, 0)
    var fileName = Localhost.getLocalScoreKeyByUserID()
    var data = Localhost.readUserDataFromStorage(fileName)
    if (data && data.scoreUpdateTime) {
        data.scoreUpdateTime = 0
        Localhost.writeUserDataToStorage(data, fileName)
    }
}
Localhost.getLastScoreSyncTime = function () {
 //ms
    var fileName = Localhost.getLocalScoreKeyByUserID()
    var data = Localhost.readUserDataFromStorage(fileName)
    if (data && data.scoreUpdateTime) {
        // WARN: maybe multi result
        return tonumber(data.scoreUpdateTime)
    }
    return 0
}
Localhost.getLevelScoreData = function () {
    var fileName = Localhost.getLocalScoreKeyByUserID()
    var data = Localhost.readUserDataFromStorage(fileName)
    return data
}
Localhost.recodeLevel = function (levelId, state) {
    var fileName = Localhost.getLocalScoreKeyByUserID()
    var data = Localhost.readUserDataFromStorage(fileName)
    if (!data) {
        data = table()
    }
    if (!data.recode) {
        data.recode = table()
    }
    function updateRecode(rec) {
        if (state > 0) {
            var p = rec.win || 0
            rec.win = p + 1
        } else if (state < 0) {
            var p = rec.fail || 0
            rec.fail = p + 1
        }
    }
    var recoded = false
    for (var _ = 1, v = data.recode[1]; v; _++, v = data.recode[_]) {
        if (v.levelId === levelId) {
            recoded = true
            updateRecode(v)
        }
    }
    if (!recoded) {
        var v = table()
        v.levelId = levelId
        updateRecode(v)
        table.insert(data.recode, v)
    }
    Localhost.writeUserDataToStorage(data, fileName)
}
Localhost.addUserScore = function (score) {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getLocalScoreKeyByUserID()
        var data = Localhost.readUserDataFromStorage(fileName) || table()
        if (!data.scores) {
            data.scores = table()
        }
        var updated = false
        var isNew = true
        for (var i = 1, v = data.scores[1]; v; i++, v = data.scores[i]) {
            if (v.levelId === score.levelId) {
                isNew = false
                if (score.star > v.star) {
                    v.star = score.star
                    updated = true
                }
                if (score.score > v.score) {
                    v.score = score.score
                    updated = true
                }
                if (updated) {
                    v.updateTime = score.updateTime
                }
                break
            }
        }
        if (isNew) {
            table.insert(data.scores, score)
        }
        if (updated || isNew) {
            Localhost.writeUserDataToStorage(data, fileName)
        }
    }
}
//从服务端同步关卡信息
Localhost.syncLevelScores = function (scores, isFromServer) {
    var uid = UserManager.getInstance().uid
    if (uid) {
        var fileName = Localhost.getLocalScoreKeyByUserID()
        var data = Localhost.readUserDataFromStorage(fileName) || table()
        if (!data.scores) {
            data.scores = table()
            data.scoreUpdateTime = 0
        }
        if (scores) {
            data.scores = scores
            if (isFromServer) {
                data.scoreUpdateTime = Localhost.time()
            }
        } else {
            data.scoreUpdateTime = 0
        }
        Localhost.writeUserDataToStorage(data, fileName)
    }
}
Localhost.setSnsUserInfo = function (openid, nickname, sex, image, unionid) {
    console.log("[preload] setSnsUserInfo", openid, nickname, sex, image, unionid)
    unionid = unionid || ""
    var config = table(
        [1, "openid", openid],
        [1, "nickname", nickname],
        [1, "sex", sex],
        [1, "image", image],
        [1, "unionid", unionid],
        [1, "ts", Localhost.timeInSec()]
    )
    cc.UserDefault.getInstance().setStringForKey(kSNSUserInfoName, table.serialize(config))
}
Localhost.getSnsUserInfo = function () {
    let defaultValue = '{"openid":"","nickname":"Clover","sex":2,"image":"","unionid":""}'
    let config = table.deserialize(cc.UserDefault.getInstance().getStringForKey(kSNSUserInfoName, defaultValue))
    // let validTime = 259200
    // if (__DEBUG){
        validTime = 180
    // }
    if(config.ts && (config.ts + validTime < Localhost.timeInSec())){
        // 缓存超过72小时，2025年1月17日前的都为过期
        config["expire"] = true
    }
    return config
}
//login
Localhost.getLastLoginUserConfig = function () {
    var config = table.deserialize(Localhost.readFromStorage(kLastLoginUserConfigName))
    if (!config) {
        config = table([1, "uid", 0])
    }
    printf("getLastLoginUserConfig:%s", table.tostring(config))
    return config
}
//存的是应用的session信息
Localhost.setLastLoginUserConfig = function (uid, sessionKey, platform) {
    if (uid == null) {
        uid = 0
    }
    var time = Localhost.time()
    var config = table(
        [1, "uid", uid],
        [1, "sk", sessionKey],
        [1, "time", time],
        [1, "p", platform]
    )
    var defaultUdid = he.MetaInfo.getInstance().getUdid()
    if (defaultUdid === sessionKey) {
        cc.log("last login udid is the same as default")
    }
    cc.log("lua setLastLoginUserConfig", tostring(uid), tostring(sessionKey))
    Localhost.writeToStorage(table.serialize(config), kLastLoginUserConfigName)
}
//user info
Localhost.getUserLocalKeyByUserID = function (uid) {
    assert(uid, "userid should not nil")
    var platform = UserManager.getInstance().platform
    var key = tostring(platform) + "_u_" + tostring(uid) + kLocalDataExt
    return key
}
Localhost.readCurrentUserData = function () {
    var currUuid = kDeviceID
    var uid = UserManager.getInstance().uid
    var fileName = Localhost.getUserLocalKeyByUserID(uid)
    var readData = Localhost.readUserDataFromStorage(fileName)
    if (readData) {
        var readUuid = readData.uuid
        if (currUuid === readUuid) {
            return readData
        } else {
            cc.log("Waining:Verify user data fail. invalid UUID!")
            printf("uid:%s", UserManager.getInstance().uid)
            return null
        }
    } else {
        cc.log("Waining:Local user data not found!")
        return null
    }
}
Localhost.getUnlockEndtime = function () {
    var data = Localhost.readCurrentUserData()
    if (data && data.user && data.user.unlockInfo && data.user.unlockInfo.endTime) {
        // WARN: maybe multi result
        return tonumber(data.user.unlockInfo.endTime)
    }
    return 0
}
Localhost.readUserDataByUserID = function (uid) {
    var currUuid = kDeviceID
    var fileName = tostring(uid) + "/" + Localhost.getUserLocalKeyByUserID(uid)
    var readData = Localhost.readFromStorage(fileName)
    if (readData) {
        //print("flushCurrentUserData:"..table.tostring(readData.openId))
        var readUuid = readData.uuid
        if (currUuid === readUuid) {
            return readData
        } else {
            cc.log("Waining:Verify user data fail. invalid UUID!")
            return null
        }
    } else {
        cc.log("Waining:Local user data not found!")
        return null
    }
}
Localhost.flushCurrentUserData = function () {
    var data = {}
    data.day = Localhost.timeInDay();
    data.markPanelShow = UserManager.getInstance().getLocalDailyData().markPanelShow;
    data.piggyBankPanelLoginShow = UserManager.getInstance().getLocalDailyData().piggyBankPanelLoginShow;
    data.piggyBankPanelFullShowCount = UserManager.getInstance().getLocalDailyData().piggyBankPanelFullShowCount;

    UserLocalSettings.setSetting("local.dailydata", JSON.stringify(data));
    return
    var uid = UserManager.getInstance().user.uid || UserManager.getInstance().uid
    cc.log("Localhost:flushCurrentUserData", uid)
    if (uid) {
        var fileName = Localhost.getUserLocalKeyByUserID(uid)
        var userData = Localhost.readUserDataFromStorage(fileName) || table()
        userData.user = UserManager.getInstance().encode()
        userData.uuid = kDeviceID
        Localhost.writeUserDataToStorage(userData, fileName)
    } else {
        cc.log("flushCurrentUserData fail, userid is nil")
    }
    // var self = this
    // var uid = UserManager.getInstance().user.uid || UserManager.getInstance().uid
    // // var uid = UserManager.getInstance().user.uid
    // cc.log("Localhost:flushCurrentUserData", uid)
    // if (uid != null) {
    //     let user_data = UserManager.getInstance().getCleanData()
    //     if(user_data !== cc.UserDefault.getInstance().getStringForKey(LOCAL_USER_KEY)){
    //         Localhost.writeUserDataToStorage(user_data)
    //     }
    // } else {
    //     cc.log("flushCurrentUserData fail, userid is nil")
    // }
}
Localhost.flushSelectedUserData = function (userData) {
    var uid = UserManager.getInstance().uid
    var fileName = Localhost.getUserLocalKeyByUserID(uid)
    Localhost.writeUserDataToStorage(userData, fileName)
}
Localhost.readLastLoginUserData = function () {
    var savedConfig = Localhost.getInstance().getLastLoginUserConfig()
    if (savedConfig.uid !== 0) {
        var uid = tostring(savedConfig.uid)
        var sessionKey = tostring(savedConfig.sk)
        var platform = tostring(savedConfig.p)
        var fileName = tostring(uid) + "/" + platform + "_u_" + uid + kLocalDataExt
        // WARN: maybe multi result
        return Localhost.readFromStorage(fileName)
    }
    return null
}
//friends
Localhost.flushCurrentFriendsData = function () {
    // local fileName = self:getUserLocalKeyByUserID(UserManager.getInstance().uid)
    // local userData = self:readUserDataFromStorage(fileName) or {}
    // if not userData.user then
    // 	print("What? user data not found?")
    // 	userData.user = UserManager.getInstance():encode()
    // end
    // userData.friends = FriendManager.getInstance():encode()
    // self:writeUserDataToStorage(userData, fileName)
}
//将string中的内容以二进制的方式写入文件,
//	此方法先创建临时文件，将内容写入临时文件，
//	最后把临时文件move成正式文件
//	注意： **此方法仅限于文件内容较少，并且一次性写入的调用
Localhost.writeToStorage = function (data, fileName) {
    Persistence.writeToStorage(data, fileName)
}
Localhost.writeUserDataToStorage = function (data, fileName) {
    // var self = this
    Persistence.writeUserDataToStorage(data, fileName)
    // cc.UserDefault.getInstance().setStringForKey(LOCAL_USER_KEY, b64Encode(JSON.stringify(data)))
}
Localhost.deleteLastLoginUserConfig = function () {
    var filePath = fullPathOfLocalData + "/" + kLastLoginUserConfigName
    cc.log("delete local last login data")
    os.remove(filePath)
}
Localhost.deleteUserDataByUserID = function (uid) {
    var fileName = Localhost.getUserLocalKeyByUserID(uid)
    var filePath = fullPathOfLocalData + "/" + fileName
    cc.log("delete local user data, uid:" + tostring(uid))
    os.remove(filePath)
}
Localhost.deleteGuideRecord = function () {
    var filePath = fullPathOfLocalData + "/guiderec"
    cc.log("delete local guide data")
    os.remove(filePath)
}
Localhost.deletePushRecord = function () {
    var filePath = fullPathOfLocalData + "/pushrec"
    cc.log("delete local push data")
    os.remove(filePath)
}
Localhost.deleteMarkPriseRecord = function () {
    var filePath = fullPathOfLocalData + "/markprise"
    cc.log("delete local guide data")
    os.remove(filePath)
}
Localhost.safeWriteStringToFile = function (data, filePath) {
    Persistence.safeWriteStringToFile(data, filePath)
}
Localhost.readFromStorage = function (fileName) {
    // WARN: maybe multi result
    return Persistence.readFromStorage(fileName)
}
Localhost.readUserDataFromStorage = function (fileName) {
    // WARN: maybe multi result
    return Persistence.readUserDataFromStorage(fileName)
}
Localhost.getRecommendData = function () {
    return null;
}
Localhost.setRecommendData = function (data) {}
Localhost.getLastLoginOauthID = function () {
    cc.log("get last login oauth---------------------")
    var config = Localhost.readUserDataFromStorage(kLastLoginOauthID)
    return config || 0
}
Localhost.getLastLoginOauthIDActual = function () {
    cc.log("get last login oauth actual---------------------")
    var config = Localhost.readUserDataFromStorage(kLastLoginOauthID)
    return config
}
Localhost.getLastLoginOauthIDForUid = function (uid) {
    var config = Localhost.readFromStorage(tostring(uid) + "/" + kLastLoginOauthID)
    return config || 0
}
Localhost.setLastLoginOauthID = function (id) {
    if (id) {
        printf("set last login oauth success---------------------%s", id)
        var uid = UserManager.getInstance().uid
        GameProxy.getInstance().setOauthType(id)
        if (uid) {
            Localhost.writeUserDataToStorage(id, kLastLoginOauthID)
        }
        cc.log("set last login oauth write success---------------------")
        return 
    }
    cc.log("set recommend data failed---------------------")
}
Localhost.deleteLastLoginOauthID = function () {
    var uid = UserManager.getInstance().uid
    var filePath = fullPathOfLocalData + "/" + tostring(uid) + "/" + kLastLoginOauthID
    cc.log("delete last login oauth---------------------")
    os.remove(filePath)
}
Localhost.cleanLoginInfo = function () {
    var buff = LoginBuffer.getInstance()
    buff.setOpenId(buff.oauthType, "", "", 0, "", 0)
    buff.flushLoginOptions()
}
Localhost.clearLastLoginUserData = function () {
    Localhost.getInstance().deleteLastLoginUserConfig()
    he.HeFileUtils.removeDir(he.HeResPathUtils.getUserDataPath() + "/" + UserManager.getInstance().uid)
    LocalNotificationManager.getInstance().cancelAllNotification()
    _G.kDeviceID = UdidUtil.revertUdid()
}
Localhost.setLastLoginTime = function () {
    Localhost.writeUserDataToStorage(tostring(Localhost.timeInSec()), kLastLoginTime)
}
Localhost.getLastLoginTime = function () {
    var time = Localhost.readUserDataFromStorage(kLastLoginTime)
    if (!time) {
        time = 0
    }
    return time
}
Localhost.setIsDealRead = function () {
    Localhost.writeToStorage("1", kIsDealRead)
}
Localhost.getIsDealRead = function () {
    return !Localhost.readFromStorage(kIsDealRead)
}
Localhost.setIsNewNamePoped = function () {
    Localhost.writeUserDataToStorage("1", kIsNewNamePoped)
}
Localhost.getIsNewNamePoped = function () {
    // WARN: maybe multi result
    // FIXME: getIsNewNamePoped
    //return Localhost.readUserDataFromStorage(kIsNewNamePoped)
    return 1;
}
Localhost.setIsNewUserDC = function () {
    var __VA_ARG = $slice(arguments, 0)
    Localhost.writeUserDataToStorage("1", kIsNewUserDC)
}
Localhost.getIsNewUserDC = function () {
    var __VA_ARG = $slice(arguments, 0)
    return Localhost.readUserDataFromStorage(kIsNewUserDC) === "1"
}
Localhost.getPayRecordInfo = function () {
    var __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return Localhost.readFromStorage(kPayRecordInfo)
}
Localhost.savePayRecordInfo = function (info) {
    Localhost.writeToStorage(info, kPayRecordInfo)
}
Localhost.setIsTestSep = function (value) {
    Localhost.writeToStorage(value && "1" || "0", kisTestSep)
}
Localhost.getIsTestSep = function () {
    return Localhost.readFromStorage(kisTestSep) === "1"
}
Localhost.setIsNewAndroidPatchFindPopTime = function () {
    Localhost.writeUserDataToStorage(tostring(Localhost.timeInSec()), kIsNewAndroidPatchFindPopTime)
}
Localhost.getIsNewAndroidPatchFindPopTime = function () {
    return Localhost.readUserDataFromStorage(kIsNewAndroidPatchFindPopTime) || "0"
}
Localhost.setIsStarGroupOpenedHistory = function () {}
Localhost.getIsStarGroupOpenedHistory = function () {}
Localhost.getIsCoinDozerPoserPoped = function () { return 0 }
Localhost.setIsCoinDozerPoserPoped = function () {}
Localhost.getEnergyShareRecord = function () {
    let __VA_ARG = $slice(arguments, 0)
    let s_data = Localhost.readUserDataFromStorage(kEnergyShareRecord)
    if (s_data) {
        let data = table.deserialize(s_data)
        return data
    }
}
Localhost.setEnergyShareRecord = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kEnergyShareRecord)
}
Localhost.getPrepropUseRecord = function () {
    let __VA_ARG = $slice(arguments, 0)
    let s_data = Localhost.readUserDataFromStorage(kPrepropUseRecord)
    if (s_data) {
        let data = table.deserialize(s_data)
        return data
    }
}
Localhost.setPrepropUseRecord = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kPrepropUseRecord)
}
Localhost.getMissionRankAnimShowTime = function () {
    var data = Localhost.readUserDataFromStorage(kMissionRankAnimShowTime)
    return data || 0
}
Localhost.setMissionRankAnimShowTime = function (day) {
    Localhost.writeUserDataToStorage(day, kMissionRankAnimShowTime)
}
Localhost.getInvitePopedDayTime = function () {
    var data = Localhost.readUserDataFromStorage(kInvitePanelPopDayTime)
    return data || 0
}
Localhost.setInvitePopedDayTime = function (day) {
    Localhost.writeUserDataToStorage(day, kInvitePanelPopDayTime)
}
Localhost.setLastPopEnergyPopTime = function () {
    Localhost.writeUserDataToStorage(Localhost.timeInSec(), kLastPopEnergyInvitePanel)
}
Localhost.getLastPopEnergyPopTime = function () {
    // WARN: maybe multi result
    return Localhost.readUserDataFromStorage(kLastPopEnergyInvitePanel)
}
var kfailLevelAnimTerminage = "failLevelAnimTerminage" + kLocalDataExt
Localhost.getFailLevelAnimTerminate = function () {
    var data = Localhost.readUserDataFromStorage(kfailLevelAnimTerminage)
    if (data) {
        return tonumber(data)
    }
    return 0
}
Localhost.setFailLevelAnimTerminate = function () {
    Localhost.writeUserDataToStorage(1, kfailLevelAnimTerminage)
}
Localhost.setRankDataCache = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kRankDataCache)
}
Localhost.getRankDataCache = function () {
    let s_data = Localhost.readUserDataFromStorage(kRankDataCache)
    if (s_data) {
        let data = table.deserialize(s_data)
        return data
    }
}
Localhost.getChallengeInfo = function () {
    let __VA_ARG = $slice(arguments, 0)
    let s_data = Localhost.readUserDataFromStorage(kChallengeShowInfo)
    if (s_data) {
        let data = table.deserialize(s_data)
        return data
    }
}
Localhost.saveChallengeInfo = function (info) {
    let s_data = table.serialize(info)
    Localhost.writeUserDataToStorage(s_data, kChallengeShowInfo)
}
//-----------------------------------------
//周赛
//-----------------------------------------
Localhost.setWeekGameDataCache = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kWeekGameDataDataCache)
}
Localhost.getWeekGameDataCache = function () {
    let s_data = Localhost.readUserDataFromStorage(kWeekGameDataDataCache)
    // if (s_data) {
    //     let data = table.deserialize(s_data)
    //     return data
    // }
    return s_data
}
Localhost.setWeekGameShareAddCountData = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kWeekGameShareAddCountData)
}
Localhost.getWeekGameShareAddCountData = function () {
    let s_data = Localhost.readUserDataFromStorage(kWeekGameShareAddCountData)
    if (s_data) {
        let data = table.deserialize(s_data)
        return data
    }
}
Localhost.setWeekGameForceOpenTimeData = function (data) {
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kWeekGameForceOpenTimeData)
}
Localhost.getWeekGameForceOpenTimeData = function () {
    let s_data = Localhost.readUserDataFromStorage(kWeekGameForceOpenTimeData)
    if (s_data) {
        let data = table.deserialize(s_data)
        if (type(data) === "table") {
            return data
        }
    }
}
//-----------------------------------------
//周赛关卡内信�?
//-----------------------------------------
Localhost.getWeekLevelCacheData = function () {
    let __VA_ARG = $slice(arguments, 0)
    // body
    let s_data = Localhost.readUserDataFromStorage(kWeekLevelCacheData)
    if (s_data) {
        // WARN: maybe multi result
        // return table.deserialize(s_data)
        return s_data
    } else {
        return table()
    }
}
Localhost.setWeekLevelCacheData = function (data) {
    // body
    let s_data = table.serialize(data)
    Localhost.writeUserDataToStorage(s_data, kWeekLevelCacheData)
}
// local kLocalDailyData = "localDailyData" .. kLocalDataExt
//--------------------------------------------
//本地缓存dailyData
//--------------------------------------------
Localhost.getDailyData = function () {
    let s_data = Localhost.readUserDataFromStorage(kLocalDailyData)
    if (!s_data || (s_data.ts  && s_data.ts !== Localhost.timeInDay())) {
        s_data = table()
        s_data.ts = Localhost.timeInDay()
    }
    return s_data
}
Localhost.setDailyDataByKey = function (key, value) {
    let s_data = Localhost.getDailyData()
    s_data[key] = value
    Localhost.writeUserDataToStorage(s_data, kLocalDailyData)
}
Localhost.getDailyDataByKey = function (key, xdefault) {
    let s_data = Localhost.getDailyData()
    if (s_data[key] ) {
        return s_data[key]
    }
    return xdefault
}

Localhost.hadDailyDataByKey = function (key) {
    let s_data = Localhost.readUserDataFromStorage(kLocalDailyData)
    if (s_data !== null && s_data[key] !== null) {
        return true
    }
    return false
}
Localhost.getPropPrompt = function () {
    let s_data = Localhost.readUserDataFromStorage(kPropPromptGuide)
    if (s_data == null) {
        s_data = table()
    }
    return s_data
}
Localhost.setPropPromptByKey = function (key, value) {
    let s_data = Localhost.getPropPrompt()
    s_data[key] = value
    Localhost.writeUserDataToStorage(s_data, kPropPromptGuide)
}
Localhost.getPropPromptByKey = function (key, xdefault) {
    let s_data = Localhost.getPropPrompt()
    if (s_data[key] != null) {
        return s_data[key]
    }
    return xdefault
}
//--
Localhost.getShowedCompenList = function () {
    return Localhost.readUserDataFromStorage(kCompenPopoutList)
}
Localhost.setShowedCompenList = function (data) {
    return Localhost.writeUserDataToStorage(data, kCompenPopoutList)
}
Localhost.addShowedCompenList = function (id) {
    let data = Localhost.getShowedCompenList() || table()
    data[tostring(id)] = true
    return Localhost.writeUserDataToStorage(data, kCompenPopoutList)
}
Localhost.haveCompenToshow = function (list, type) {
    let data = Localhost.getShowedCompenList() || table()
    list = list || table()
    let count = 0
    for (let key in list) {
        let v = list[key];
        if (!v) {
            continue
        }
        if (type != null) {
            if (!data[v.id] && v.type === type) {
                count ++
            }
        }else {
            if (!data[v.id]) {
                count ++
            }
        }
    }
    return count
}
Localhost.isWantedGuideShowed = function () {
    return true;
}
Localhost.setWantedGuideShowed = function () {}
Localhost.isInDay = function () {
    let data = os.date()
    return (data.hour >= 6 && data.hour < 18)
}
let pvpRedDotSettingKey = "pvpRedDotSettings"
Localhost.shouldShowPvpRedDot = function () {
    let settings = UserLocalSettings.getSetting(pvpRedDotSettingKey, {
        lastShowDay: 0,
        showTimes: 0
    })
    let today = Localhost.timeInDay()
    if ((settings.lastShowDay === 0 || today > settings.lastShowDay) && settings.showTimes < 3) {
        return true
    }
    return false
}
Localhost.setPvpClickToday = function () {
    let settings = UserLocalSettings.getSetting(pvpRedDotSettingKey, {
        lastShowDay: 0,
        showTimes: 0
    })
    let lastDay = settings.lastShowDay
    let now = Localhost.timeInDay()
    if (lastDay !== now) {
        settings.lastShowDay = now
        settings.showTimes += 1
        UserLocalSettings.setSetting(pvpRedDotSettingKey, settings)
    }
}
//--------------------------------------------
//掉落优化缓存数据
//--------------------------------------------
//获取掉落优化缓存数据
Localhost.getDropAdjustData = function () {
    let self = this
    return self.readUserDataFromStorage(LocalDataFiles.kDropAdjustData) || table()
}
//更新掉落优化缓存数据
Localhost.setDropAdjustData = function (data) {
    let self = this
    self.writeUserDataToStorage(data, LocalDataFiles.kDropAdjustData)
}
//获取掉落优化缓存数据，新计数用
Localhost.getDropAdjustDataV2 = function () {
    let self = this
    return self.readUserDataFromStorage(LocalDataFiles.kDropAdjustDataV2) || table()
}
//更新掉落优化缓存数据，新计数用
Localhost.setDropAdjustDataV2 = function (data) {
    let self = this
    self.writeUserDataToStorage(data, LocalDataFiles.kDropAdjustDataV2)
}

Localhost.readDAUserDataV2 = function () {
    let self = this
    let cache = self.readUserDataFromStorage(kDAUserDataV2Cache)
    if (!cache) {
        cache = "{}"
    }
    cc.log("#### DA readDAUserDataV2", cache)
    return cache
    // return "{}"
}
Localhost.writeDAUserDataV2 = function (cache) {
    let self = this
    cc.log("#### DA writeDAUserDataV2", cache)
    self.writeUserDataToStorage(cache, kDAUserDataV2Cache)
}